import React from 'react';

import AppWrapper from '../AppWrapper';
import ApiKey from './forms/ApiKey';
import TrustPilot from './forms/TrustPilot';
import FacebookAds from './forms/FacebookAds';

import axios from 'axios';
import Notification from '../../../components/Notification';
import {hashHistory} from 'react-router';
import General from '../../../modules/General';

const apps = {
    ApiKey: ApiKey,
    TrustPilot:TrustPilot,
    FacebookAds:FacebookAds
};


class Basic extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isWaiting:false,
			error:false
		}

		this.handleInstall = this.handleInstall.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	handleSubmit(values) {
		if(this.props.app.installed) {
			this.handleUpdate(values);
		}else{
			this.handleInstall(values);
		}
	}

	handleUpdate(values) {
		this.setState({isWaiting:true});
		axios.put('/apps/'+this.props.app.key,values)
		.then(res => {
			Notification.success('Success!');
            hashHistory.push(General.Link('/apps'));
		}).catch(err => {
			this.setState({isWaiting:false,'error':err.response.data.error.message});
		});
	}

	handleInstall(values) {
		this.setState({isWaiting:true});
		axios.post('/apps/'+this.props.app.key,values)
		.then(res => {
			Notification.success('Success!');
			hashHistory.push(General.Link('/apps'));
		}).catch(err => {
			this.setState({isWaiting:false,'error':err.response.data.error.message});
		});
	}
	render() {
        const FormComponent = apps[this.props.app.form];

		return (
			<AppWrapper title={this.props.app.title} image={this.props.app.image}>
				<FormComponent err={this.state.error} initialValues={this.props.app.installed ? this.props.app.config:{}} app={this.props.app} isWaiting={this.state.isWaiting} onSubmit={this.handleSubmit} />
			</AppWrapper>
		)
	}	
}

export default Basic;



// WEBPACK FOOTER //
// ./containers/apps/apps/Basic.js